type RpcResult = { data: unknown; error: unknown }
type BreakGlassClient = {
  auth: { getUser(): Promise<{ data: { user: { id: string } | null }; error: unknown }> }
  rpc(name: string, args?: Record<string, unknown>): PromiseLike<RpcResult>
}

export function queueErrorMessage(error: unknown): string {
  const details = error && typeof error === 'object' ? error as { code?: string; message?: string } : null
  if (details?.code === '42501') return 'נדרש משתמש מחובר עם הרשאת מנהל ראשי. יש להתחבר מחדש אם ההרשאה כבר קיימת.'
  return details?.message || (typeof error === 'string' ? error : 'הפעולה נכשלה')
}

export async function requestQueueBreakGlass(
  client: BreakGlassClient,
  action: 'open' | 'close',
  reason: string,
  previewOnly = false,
): Promise<{ active_until: string | null }> {
  if (previewOnly) throw new Error('תצוגה מקומית בלבד — הפעולה אינה נשלחת לשרת')
  if (action !== 'open' && action !== 'close') throw new Error('פעולה לא תקינה')
  const trimmedReason = reason.trim()
  if (!trimmedReason) throw new Error('נדרשת סיבה')
  const identity = await client.auth.getUser()
  if (identity.error || !identity.data.user) throw new Error('נדרשת התחברות מחדש לפני שינוי חלון break-glass')
  const access = await client.rpc('is_super_admin')
  if (access.error) throw new Error(queueErrorMessage(access.error))
  if (access.data !== true) throw new Error('הפעולה דורשת הרשאת מנהל ראשי')
  const result = await client.rpc('migration_queue_break_glass', {
    p_action: action, p_reason: trimmedReason, p_minutes: 30,
  })
  if (result.error) throw new Error(queueErrorMessage(result.error))
  const data = result.data as { active_until?: unknown } | null
  if (!data || (action === 'open'
    ? typeof data.active_until !== 'string' || !Number.isFinite(Date.parse(data.active_until))
    : data.active_until !== null)) {
    throw new Error('לא התקבל אישור תקין לחלון break-glass; יש לרענן את מצב התור')
  }
  return { active_until: data.active_until as string | null }
}
